import { getApiBaseUrl } from "@/shared/lib/apiClient";
import { getAuthToken } from "../auth";

async function openHtmlReport(url: string, errorLabel: string): Promise<void> {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Connexion requise.");
  }

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/html",
    },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || errorLabel);
  }

  const html = await response.text();
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const objectUrl = URL.createObjectURL(blob);
  // Pas de "noopener" dans les features : window.open renverrait toujours null
  // (faux message « pop-ups bloqués »). On coupe le lien opener manuellement.
  const popup = window.open(objectUrl, "_blank");
  if (!popup) {
    URL.revokeObjectURL(objectUrl);
    throw new Error("Autorisez les pop-ups pour afficher l'impression.");
  }
  popup.opener = null;
  popup.addEventListener("load", () => URL.revokeObjectURL(objectUrl), { once: true });
}

export async function openInvoicePrint(invoiceId: number): Promise<void> {
  await openHtmlReport(
    `${getApiBaseUrl()}/invoices/${invoiceId}/print`,
    "Impression impossible.",
  );
}

export async function openInvoiceForfaitReport(
  invoiceId: number,
  pricing: "prestataire" | "client" = "prestataire",
): Promise<void> {
  const qs = pricing === "client" ? "?pricing=client" : "";
  await openHtmlReport(
    `${getApiBaseUrl()}/invoices/${invoiceId}/forfait-report${qs}`,
    "Impression forfait impossible.",
  );
}

export async function openInvoiceRefractionSheet(invoiceId: number): Promise<void> {
  await openHtmlReport(
    `${getApiBaseUrl()}/auditor/invoices/${invoiceId}/refraction`,
    "Génération de la fiche de réfraction impossible.",
  );
}

export async function downloadInvoiceRefractionXlsx(invoiceId: number): Promise<void> {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Connexion requise.");
  }

  const response = await fetch(`${getApiBaseUrl()}/auditor/invoices/${invoiceId}/refraction/xlsx`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Export Excel impossible.");
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = `fiche-refraction-facture-${invoiceId}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}

export async function openInvoiceAiReport(
  invoiceId: number,
  mode: "revised" | "complete" = "revised",
): Promise<void> {
  const qs = mode === "complete" ? "?mode=complete" : "";
  await openHtmlReport(
    `${getApiBaseUrl()}/invoices/${invoiceId}/ai-report${qs}`,
    "Génération facture IA impossible.",
  );
}
